<template>
    <div>
        <a :name="anchor" class="anchor"></a>
        <component :is="`h${level}`">{{ title }}</component>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'GuideSpecification',

        props: {
            title: String,
        },

        computed: {
            anchor() {
                return this.title
                    .toLowerCase()
                    .split(' ')
                    .join('-')
                    .replace('(', '')
                    .replace(')', '');
            },
        },

        data() {
            return {
                level:
                    this.$parent.$options._componentTag === 'GuideSpecification'
                        ? (this.$parent.level || 0) + 1
                        : 1,
            };
        },
    };
</script>
